const Backbone = require('backbone');
const DefaultView = require('../views/default');
require('../views/meta-tags');


const Router = Backbone.Router.extend({
	routes: {
		"": "defaultController",
		":module": "defaultController",
		":module/:method": "defaultController",
		":module/:method/*params": "defaultController",
	},
	defaultController: function(module, method, params) {
		if (undefined == module) {
			module = 'home';
		}
		if (undefined == method) {
			method = 'index';
		}
		if (undefined == params) {
			params = [];
		} else {
			var params = params.split(/\//igm);
		}

		if (undefined != this.view) {
			this.view.undelegateEvents();
		}

		//console.log(arguments);

		this.view = new DefaultView({			
			template: `${module}/${method}.twig`,
			model: new Backbone.Model({
				module: module,
				method: method,
				params: params
			})
		});

	}
});

new Router();


//////////////////
// WEBPACK FOOTER
// ./js/routers/default.js
// module id = 14
// module chunks = 0